/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { getLabel } from '../../../utils/i18n';
import withi18n from '../../../utils/withI18n';
import { Link } from '../../../routes';

const StyledButton = styled.button`
  border: none;
  outline: none;
  height: 34px;
  line-height: 34px;
  border-radius: 17px;
  padding: 0 20px;
  background: rgba(240, 185, 11, 1) url(${require('./button_bg.png')}) repeat-x left center;
  font-size: 14px;
  font-weight: 500;
  color: rgba(33, 40, 51, 1);
  cursor: pointer;
`;

type Props = {
  i18n: Object,
  locale: string,
  // agentRewardRatio: number,
};

// const mapStateToProps = ({ locale }) =>
//   const { agentRewardRatio } = userInfo;
//   ({
//     locale,
//     agentRewardRatio,
//   });
const mapStateToProps = ({ locale }) => ({
  locale,
});
export default
@withi18n
@connect(mapStateToProps)
class ReferralEntry extends React.PureComponent<Props> {
  static defaultProps = {
    locale: 'en',
    i18n: {},
    // agentRewardRatio: 0,
  };

  render() {
    const { i18n, locale } = this.props;
    // const rate = `${agentRewardRatio * 100}%`;
    return (
      <Link route={`/${locale}/referral-details`}>
        <StyledButton>
          {getLabel('usExchange-referral-entry-cta', i18n)}
        </StyledButton>
      </Link>
    );
  }
}
